import { createSelector } from '@ngrx/store'
import { selectPayoutAgreementState } from './payout-agreement.reducers'
import { PayoutAgreementState } from './payout-agreement.state'

export const selectStatutoryCompliances = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state.payout?.statutoryCompliances ?? null
)

export const selectPayoutFrequency = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state.payout?.payoutFrequency ?? null
)

export const selectCtc = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state.payout?.ctc ?? null
)

export const selectCtcData = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => ({
    payoutFrequency: state?.payout?.payoutFrequency ?? null,
    basis: state?.payout?.basis ?? null,
    ctc: state?.payout?.ctc ?? null,
    currency: state?.payout?.currency ?? null,
    effectiveFrom: state?.payout?.effectiveFrom ?? null,
    payoutFrom: state?.payout?.payoutFrom ?? null
  })
)

export const selectBasis = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state.payout?.basis ?? null
)

export const selectEffectiveFrom = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state.payout?.effectiveFrom ?? null
)

export const selectOtherComponents = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state?.payout?.payoutData?.otherComponents ?? null
)

export const selectPayoutData = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state?.payout?.payoutData ?? null
)

// --- Revision Workflow Selectors ---
export const selectRevisedStatutoryCompliances = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state?.revisedPayout?.statutoryCompliances ?? null
)

export const selectRevisedCtc = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state?.revisedPayout?.ctc ?? null
)

export const selectRevisedCtcData = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => ({
    payoutFrequency: state?.revisedPayout?.payoutFrequency ?? null,
    basis: state?.revisedPayout?.basis ?? null,
    ctc: state?.revisedPayout?.ctc ?? null,
    currency: state?.revisedPayout?.currency ?? null,
    effectiveFrom: state?.revisedPayout?.effectiveFrom ?? null,
    payoutFrom: state?.revisedPayout?.payoutFrom ?? null
  })
)

export const selectRevisedOtherComponents = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state?.revisedPayout?.payoutData?.otherComponents ?? null
)

export const selectRevisedPayoutData = createSelector(
  selectPayoutAgreementState,
  (state: PayoutAgreementState) => state?.revisedPayout?.payoutData ?? null
)
